// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScratchSimpleSelectOption_bckdrp__E7slo {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: transparent;
  z-index: 1;
}
.ScratchSimpleSelectOption_container__RCUca {
  width: 100%;
  position: relative;
}
.ScratchSimpleSelectOption_fullHeight__XWDPV {
  height: 100%;
}
.ScratchSimpleSelectOption_selectInput__vcJS8 {
  height: 50px;
  padding-bottom: 1px;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  padding-inline: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.ScratchSimpleSelectOption_tableSearchSelectInput__cy7dh {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-inline: 10px;
}
.ScratchSimpleSelectOption_label__f-TZD {
  position: absolute;
  color: currentColor;
  transition: all 0.3s ease-out;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.ScratchSimpleSelectOption_arrowLabel__4HYm1 {
  position: absolute;
  margin-inline-start: calc(100% - 25px);
  margin-top: 8px;
  display: flex;
  align-items: center;
  /* cursor: pointer; */
  /* color: currentColor;
  fill: currentColor; */
  transition: all 0.3s ease-out;
  transform: rotate(0);
}
.ScratchSimpleSelectOption_tableSearchArrowLabel__3kimo {
  position: absolute;
  margin-inline-start: calc(100% - 25px);
  margin-top: 1px;
  display: flex;
  align-items: center;
  /* color: currentColor;
  fill: currentColor; */
  transition: all 0.3s ease-out;
  transform: rotate(0);
}
.ScratchSimpleSelectOption_labelsContainer__VFHMU {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  height: 100%;
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.ScratchSimpleSelectOption_reversedIcon__KITtV {
  transform: rotate(180deg);
}
.ScratchSimpleSelectOption_optionsContainer__ecNEG {
  position: absolute;
  min-width: 100%;
  padding: 10px 0;
  background-color: #fff;
  top: calc(100% + 1px);
  z-index: 2;
  border: 1px solid #efefef;
  box-shadow: 0px 0px 20px 3px #c5c5c556;
  border-radius: 4px;
  max-height: 370px;
  overflow-y: auto;
}
.ScratchSimpleSelectOption_optionInput__9rx3I {
  /* height: 40px; */
  width: 100%;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.ScratchSimpleSelectOption_tableSearchOptionInput__7fKk6 {
  height: 40px;
  width: 100%;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #5a5a5a;
  fill: #5a5a5a;
}
.ScratchSimpleSelectOption_optionInput__9rx3I:hover,
.ScratchSimpleSelectOption_tableSearchOptionInput__7fKk6:hover {
  background-color: rgba(88, 88, 88, 0.1);
}
.ScratchSimpleSelectOption_focusedOption__zBYP3 {
  background-color: rgba(88, 88, 88, 0.24);
}

.ScratchSimpleSelectOption_labelUp__G2syo {
  top: -10px;
  cursor: default;
  margin-inline-start: 10px;
}
.ScratchSimpleSelectOption_labelDown__qrmAj {
  width: calc(100% - 35px) !important;
  top: 12px;
  cursor: text;
  cursor: pointer;
  margin-inline-start: 6px;
}
.ScratchSimpleSelectOption_autoCursor__zCdP6 {
  cursor: auto;
}
.ScratchSimpleSelectOption_mandatorySign__e7Ypn {
  padding-inline-start: 5px;
}
.ScratchSimpleSelectOption_hiddenInput__PJkPo {
  /* display: none !important; */
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
  z-index: -1;
}
.ScratchSimpleSelectOption_disabledCursor__DSpsL {
  cursor: default;
}
.ScratchSimpleSelectOption_mounted__Z-laU {
  animation: ScratchSimpleSelectOption_inAnimationx__OgDhG 250ms ease-in;
}
.ScratchSimpleSelectOption_unmounted__Q3JVg {
  animation: ScratchSimpleSelectOption_outAnimationx__tSvEr 270ms ease-out forwards;
}
.ScratchSimpleSelectOption_finalValue__QVhTQ {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 15px);
  padding-bottom: 5px;
}
@keyframes ScratchSimpleSelectOption_inAnimationx__OgDhG {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes ScratchSimpleSelectOption_outAnimationx__tSvEr {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/ScratchSimpleSelectOption/ScratchSimpleSelectOption.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB;uBACqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB;uBACqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,SAAS;EACT,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,sEAAqC;AACvC;AACA;EACE,iFAAgD;AAClD;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF","sourcesContent":[".bckdrp {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: transparent;\r\n  z-index: 1;\r\n}\r\n.container {\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n.fullHeight {\r\n  height: 100%;\r\n}\r\n.selectInput {\r\n  height: 50px;\r\n  padding-bottom: 1px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding-inline: 10px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.tableSearchSelectInput {\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-inline: 10px;\r\n}\r\n.label {\r\n  position: absolute;\r\n  color: currentColor;\r\n  transition: all 0.3s ease-out;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.arrowLabel {\r\n  position: absolute;\r\n  margin-inline-start: calc(100% - 25px);\r\n  margin-top: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  /* cursor: pointer; */\r\n  /* color: currentColor;\r\n  fill: currentColor; */\r\n  transition: all 0.3s ease-out;\r\n  transform: rotate(0);\r\n}\r\n.tableSearchArrowLabel {\r\n  position: absolute;\r\n  margin-inline-start: calc(100% - 25px);\r\n  margin-top: 1px;\r\n  display: flex;\r\n  align-items: center;\r\n  /* color: currentColor;\r\n  fill: currentColor; */\r\n  transition: all 0.3s ease-out;\r\n  transform: rotate(0);\r\n}\r\n.labelsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  /* justify-content: space-between; */\r\n  height: 100%;\r\n  width: 100%;\r\n  position: absolute;\r\n  cursor: pointer;\r\n}\r\n\r\n.reversedIcon {\r\n  transform: rotate(180deg);\r\n}\r\n.optionsContainer {\r\n  position: absolute;\r\n  min-width: 100%;\r\n  padding: 10px 0;\r\n  background-color: #fff;\r\n  top: calc(100% + 1px);\r\n  z-index: 2;\r\n  border: 1px solid #efefef;\r\n  box-shadow: 0px 0px 20px 3px #c5c5c556;\r\n  border-radius: 4px;\r\n  max-height: 370px;\r\n  overflow-y: auto;\r\n}\r\n.optionInput {\r\n  /* height: 40px; */\r\n  width: 100%;\r\n  padding: 6px 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n.tableSearchOptionInput {\r\n  height: 40px;\r\n  width: 100%;\r\n  padding: 4px 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  color: #5a5a5a;\r\n  fill: #5a5a5a;\r\n}\r\n.optionInput:hover,\r\n.tableSearchOptionInput:hover {\r\n  background-color: rgba(88, 88, 88, 0.1);\r\n}\r\n.focusedOption {\r\n  background-color: rgba(88, 88, 88, 0.24);\r\n}\r\n\r\n.labelUp {\r\n  top: -10px;\r\n  cursor: default;\r\n  margin-inline-start: 10px;\r\n}\r\n.labelDown {\r\n  width: calc(100% - 35px) !important;\r\n  top: 12px;\r\n  cursor: text;\r\n  cursor: pointer;\r\n  margin-inline-start: 6px;\r\n}\r\n.autoCursor {\r\n  cursor: auto;\r\n}\r\n.mandatorySign {\r\n  padding-inline-start: 5px;\r\n}\r\n.hiddenInput {\r\n  /* display: none !important; */\r\n  opacity: 0;\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  z-index: -1;\r\n}\r\n.disabledCursor {\r\n  cursor: default;\r\n}\r\n.mounted {\r\n  animation: inAnimationx 250ms ease-in;\r\n}\r\n.unmounted {\r\n  animation: outAnimationx 270ms ease-out forwards;\r\n}\r\n.finalValue {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  width: calc(100% - 15px);\r\n  padding-bottom: 5px;\r\n}\r\n@keyframes inAnimationx {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n@keyframes outAnimationx {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bckdrp": `ScratchSimpleSelectOption_bckdrp__E7slo`,
	"container": `ScratchSimpleSelectOption_container__RCUca`,
	"fullHeight": `ScratchSimpleSelectOption_fullHeight__XWDPV`,
	"selectInput": `ScratchSimpleSelectOption_selectInput__vcJS8`,
	"tableSearchSelectInput": `ScratchSimpleSelectOption_tableSearchSelectInput__cy7dh`,
	"label": `ScratchSimpleSelectOption_label__f-TZD`,
	"arrowLabel": `ScratchSimpleSelectOption_arrowLabel__4HYm1`,
	"tableSearchArrowLabel": `ScratchSimpleSelectOption_tableSearchArrowLabel__3kimo`,
	"labelsContainer": `ScratchSimpleSelectOption_labelsContainer__VFHMU`,
	"reversedIcon": `ScratchSimpleSelectOption_reversedIcon__KITtV`,
	"optionsContainer": `ScratchSimpleSelectOption_optionsContainer__ecNEG`,
	"optionInput": `ScratchSimpleSelectOption_optionInput__9rx3I`,
	"tableSearchOptionInput": `ScratchSimpleSelectOption_tableSearchOptionInput__7fKk6`,
	"focusedOption": `ScratchSimpleSelectOption_focusedOption__zBYP3`,
	"labelUp": `ScratchSimpleSelectOption_labelUp__G2syo`,
	"labelDown": `ScratchSimpleSelectOption_labelDown__qrmAj`,
	"autoCursor": `ScratchSimpleSelectOption_autoCursor__zCdP6`,
	"mandatorySign": `ScratchSimpleSelectOption_mandatorySign__e7Ypn`,
	"hiddenInput": `ScratchSimpleSelectOption_hiddenInput__PJkPo`,
	"disabledCursor": `ScratchSimpleSelectOption_disabledCursor__DSpsL`,
	"mounted": `ScratchSimpleSelectOption_mounted__Z-laU`,
	"inAnimationx": `ScratchSimpleSelectOption_inAnimationx__OgDhG`,
	"unmounted": `ScratchSimpleSelectOption_unmounted__Q3JVg`,
	"outAnimationx": `ScratchSimpleSelectOption_outAnimationx__tSvEr`,
	"finalValue": `ScratchSimpleSelectOption_finalValue__QVhTQ`
};
export default ___CSS_LOADER_EXPORT___;
